<template>
    <div class="container">
        <v-card>
                <v-card-title class="titulopagina">PLANILLA DE PROCESO</v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col class="text-right">
                            <v-btn class="green darken-2" darken @click="agregar">
                                <v-icon >add</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card>
                <table class="tabla">
                <thead>
                        <tr>
                            <th>Fecha</th>
                            <th>Turno</th>
                            <th>J. Turno</th>
                            <th>Stock en Pozos</th>
                            <th>Stock en Patio</th>
                            <th>Horas Proceso</th>
                            <th>Velocidad de Proceso (Ton/Hr)</th>
                            <th>Horas Detención</th>
                            <th>Justificación</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,idx) in lista" :key="idx">
                            <td class="text-center">
                                <input class="input" type="date" name="" id="" v-model="item.fecha">
                            </td>
                            <td class="text-center">
                                <!-- <select name="" id="" class="input">
                                    <option value="">-- Seleccione --</option>
                                    <option value="" v-for="t in turnos" :key="t.id">{{`${t.nombre_turno} (${t.hora_inicio})`}}</option>
                                </select> -->

                                <vue-select :reduce="item => item.id" label="hora_inicio" :options="turnos" style="min-width:180px;" v-model="item.turnos_id">
                                    <template #option="{ nombre_turno, hora_inicio }">
                                    {{`${hora_inicio} (${nombre_turno})` }}
                                    </template>
                                </vue-select>

                            </td>
                            <td class="text-center">

                                <vue-select :reduce="item => item.id" label="name" :options="jefes" style="min-width:180px;" v-model="item.users_id"></vue-select>
                            </td>
                            <td class="text-center">
                                <input type="number" name="" id="" class="input" v-model="item.stock_pozo_ton">
                            </td>
                            <td class="text-center">
                                <input type="number" name="" id="" class="input" v-model="item.stock_patio_ton">
                            </td>
                            <td class="text-center">
                                <input type="number" name="" id="" class="input" v-model="item.horas_proceso">
                            </td>
                            <td class="text-center">
                                <input type="number" name="" id="" class="input" v-model="item.velocidad_proceso">
                            </td>
                            <td class="text-center">
                                <input type="number" name="" id="" class="input" v-model="item.horas_detencion">
                            </td>
                            <td class="text-center">

                                <vue-select style="min-width:250px;" v-model="item.planilla_proceso_justificaciones_id" :reduce="item => item.id" label="nombre" :options="justificaciones" @option:created="nueva_justificacion" :taggable="true"></vue-select>
                            </td>
                        </tr>
                    </tbody>
            </table>
            </v-card>
            <pre>{{lista}}</pre>
    </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex';

// import axios from 'axios'
export default {
    data:()=>({
        lista:[],
        jefes:[],
        turnos:[],
        justificaciones:[],
    }),
    created() {
        // Event.$on('peticion_realizada',()=>{
        //     this.cargarDatos()
        // })
    },
    mounted() {
        this.cargarJefesProduccion()
    },
    methods: {

        async cargarJefesProduccion(){
            this.mostrarLoading({titulo:'Cargando Jefes de Producción...',color:'green'})

            let url = `${this.base_url}user/jefes`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('jefes',response.data.data);
                this.jefes = response.data.data
                this.ocultarLoading()
            }).catch((error)=>{
                console.log(error)
                this.ocultarLoading()
            });
            this.cargarTurnos();
        },

        async cargarTurnos(){
            this.mostrarLoading({titulo:'Cargando Turnos...',color:'green'})

            let url = `${this.base_url}cargar_turnos`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('turnos',response.data.data);
                this.turnos = response.data.data
                this.ocultarLoading()
            }).catch((error)=>{
                console.log(error)
                this.ocultarLoading()
            })
            this.cargarJustificaciones();
        },

        async cargarJustificaciones(){
            this.mostrarLoading({titulo:'Cargando Justificaciones...',color:'green'})

            let url = `${this.base_url}cargar_justificaciones`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('justificaciones',response.data.data);
                this.justificaciones = response.data.data
                this.ocultarLoading()
            }).catch((error)=>{
                console.log(error)
                this.ocultarLoading()
            })
        },

        async cargarDatos(){
            //this.mostrarLoading('Cargando Datos...')
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})

            let url = `${this.base_url}parametros`
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('respuesta',response);
                this.lista = response.data.data
                this.ocultarLoading()
            }).catch((error)=>{
                console.log(error)
                this.ocultarLoading()
            })
        },

        async agregar(){
            this.lista.push({
                id:null,
                fecha:this.moment().format("YYYY-MM-DD"),
                turnos_id:null,
                users_id:null,
                stock_pozo_ton:null,
                stock_patio_ton:null,
                horas_proceso:null,
                velocidad_proceso:null,
                horas_detencion:null,
                planilla_proceso_justificaciones_id:null
            });
        },

        async nueva_justificacion($event){
            console.log($event);
            
            await this.axios.post(`${this.base_url}nueva_justificacion`,{nombre:$event.nombre.toLowerCase()},this.headers).then((r)=>{
                console.log('justificacion creada',r.data.data);
                this.justificaciones = r.data.data;
            }).catch(e=>{
                alert(e);
            })
            //console.log($event.nombre.toLowerCase());
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers'])
    },
    components:{
    }
}
</script>
<style scoped>
.input{
    border:1px #c3c3c3 solid;
}

.tabla > thead > tr > th{
    padding: 0.5em 1em;
}

.tabla > tbody > tr > td{
    padding: 0.5em 1em;
}

tr{
    border-bottom: 1px solid #c3c3c3 !important;
}

table{
    width:100%;
    border-collapse: collapse;
}

input[type=number]{
    max-width:80px;
}
</style>